import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
} from '@mui/material';
import {
  Download as DownloadIcon,
  WhatsApp as WhatsAppIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

export const Reports: React.FC = () => {
  const reports = [
    { id: 'RPT001', patient: 'John Doe', test: 'CBC', date: '26/02/2026', status: 'Ready' },
    { id: 'RPT002', patient: 'Jane Smith', test: 'Thyroid', date: '26/02/2026', status: 'Pending' },
    { id: 'RPT003', patient: 'Raj Kumar', test: 'Lipid Profile', date: '25/02/2026', status: 'Ready' },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Reports
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Report ID</TableCell>
              <TableCell>Patient</TableCell>
              <TableCell>Test</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((report) => (
              <TableRow key={report.id}>
                <TableCell>{report.id}</TableCell>
                <TableCell>{report.patient}</TableCell>
                <TableCell>{report.test}</TableCell>
                <TableCell>{report.date}</TableCell>
                <TableCell>
                  <Chip 
                    label={report.status} 
                    color={report.status === 'Ready' ? 'success' : 'warning'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Box display="flex" gap={1}>
                    <IconButton size="small" color="primary">
                      <DownloadIcon />
                    </IconButton>
                    <IconButton size="small" color="success">
                      <WhatsAppIcon />
                    </IconButton>
                    <IconButton size="small" color="info">
                      <EmailIcon />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};